import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './dish-details.scss';


export default function DishDetailsInnerBlock({ type, children }) {
    const rootClasses = classNames({
        'ny__details-container__root': true,
        [type]: type,
        'how-much': type === 'howMuch',
        empty: !children,
    });

    return (
        <div styleName={rootClasses}>
            {children}
        </div>
    );
}

DishDetailsInnerBlock.propTypes = {
    type: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};
